import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1555.2,417.882353 L1566.49412,433.694118 C1650.07059,555.670588 1694.11765,697.976471 1694.11765,847.058824 L1694.11765,847.058824 L1694.11765,1242.35294 C1694.11765,1366.58824 1795.76471,1468.23529 1920,1468.23529 L1920,1468.23529 L1920,1581.17647 L1298.82353,1581.17647 C1298.82353,1767.52941 1146.35294,1920 960,1920 C773.647059,1920 621.176471,1767.52941 621.176471,1581.17647 L621.176471,1581.17647 L621.176471,1532.61176 L1555.2,417.882353 Z M1016.49318,-0.0338823529 L1016.49318,115.730824 C1093.18024,121.490824 1168.17318,138.657882 1240.00376,168.022588 C1297.03906,192.192 1349.10494,222.234353 1395.86259,256.907294 L1395.86259,256.907294 L1594.41318,20.1825882 L1680.92612,92.8037647 L212.690824,1843.392 L126.177882,1770.77082 L285.199059,1581.14259 L0.0225882353,1581.14259 L0.0225882353,1468.20141 C59.7684706,1468.20141 118.159059,1444.14494 159.947294,1402.24376 C201.848471,1360.45553 225.904941,1302.17788 225.904941,1242.31906 L225.904941,1242.31906 L225.904941,847.024941 C225.904941,461.330824 525.086118,144.869647 903.552,115.843765 L903.552,115.843765 L903.552,-0.0338823529 L1016.49318,-0.0338823529 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMutedSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconMutedSolid, _Component);

  var _super = _createSuper(IconMutedSolid);

  function IconMutedSolid() {
    _classCallCheck(this, IconMutedSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconMutedSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMuted",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMutedSolid.displayName = "IconMutedSolid";
  return IconMutedSolid;
}(Component);

IconMutedSolid.glyphName = 'muted';
IconMutedSolid.variant = 'Solid';
IconMutedSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMutedSolid;
export { IconMutedSolid };